/* Search-page-only adapter; optional color eligibility is requested on selection. */
(() => {
  const node = document.getElementById('dac-search-extra-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  let busy = false, generation = 0, checkedAt = 0;
  const read = () => new URL(location.href);
  function sync() {
    const url = read();
    document.querySelectorAll('[data-dac-search-extra] input').forEach(input => {
      input.checked = url.searchParams.get(input.name === 'dac_search_sale' ? 'rb_discount' : 'dac_colors100') === '1';
      input.disabled = busy;
    });
  }
  async function colorIds() {
    const url = new URL(config.endpoint);url.pathname='/api/search-colors';url.searchParams.set('theme',config.theme);
    const response = await fetch(url,{credentials:'omit',referrerPolicy:'no-referrer',signal:AbortSignal.timeout(120000)});
    if (!response.ok) throw new Error('Color filtering is temporarily unavailable. Please try again.');
    const result = await response.json();
    if (!Array.isArray(result.ids) || result.ids.some(id => !/^\d+$/.test(id))) throw new Error('Invalid filter response');
    return result.ids.join('|') || '0';
  }

  async function refreshActive() {
    if (busy || read().searchParams.get('dac_colors100') !== '1' || Date.now() - checkedAt < 120000) return;
    checkedAt = Date.now(); busy = true;
    try {
      const ids = await colorIds(), url = read();
      if (url.searchParams.get('dac_colors100') !== '1') return;
      if (url.searchParams.get('rb_product_id') !== ids) {
        url.searchParams.set('rb_product_id',ids);url.searchParams.delete('page');if (config.theme === '179853918401') url.searchParams.set('preview_theme_id',config.theme); else url.searchParams.delete('preview_theme_id');location.replace(url);
      }
    } catch (_) {
      document.querySelectorAll('[data-dac-search-extra] [role="status"]').forEach(el => {el.textContent = "Farvematch kunne ikke opdateres. Slå filteret fra og til for at prøve igen.";});
    } finally {busy = false;sync();}
  }
  function mount() {
    const sale = document.getElementById('dac-search-sale-template');
    const colors = document.getElementById('dac-search-colors-template');
    if (!sale || !colors) return;
    document.querySelectorAll('.snize-filters-sidebar, #snize-modal-mobile-filters-dialog .snize-modal-content').forEach(target => {
      const price = target.querySelector('[id="snize_product_filter_price"], [id="snize_filters_block_price"] .snize-product-filters-list');
      if (price && !price.querySelector('[data-dac-search-extra="sale"]')) {
        const content = sale.content.cloneNode(true);
        if (price.tagName === 'UL') {const item = document.createElement('li');item.append(content);price.prepend(item);}
        else price.prepend(content);
      }
      if (!target.querySelector('[data-dac-search-extra="colors"]')) target.append(colors.content.cloneNode(true));
      const ranks = {Availability:10,Price:30,'Product type':40,Themes:50,Artist:60,'Canvas size':70,'Canvas layout':80,'Diamond shape':90,'Project guidance':100,'Special Drills':110,'Special drills':110,'Diamond area coverage':120,'Diamond count':130,'Colors Count':140,Rating:150};
      const groups = Array.from(target.children).filter(el => el.classList.contains('snize-product-filters-header') && el.querySelector('[id^="snize_filters_block_"][id$="_title"]')).map(header => {
        const title = header.querySelector('[id^="snize_filters_block_"][id$="_title"]').textContent.replace(/,.*$/, '').trim();
        const id = header.id.replace('snize_product_filter_header_','snize_product_filter_');
        const body = Array.from(target.children).find(el => el.id === id);
        return {header,body,rank:ranks[title] ?? 135};
      }).filter(group => group.body && !group.header.id.endsWith('sort_by'));
      Array.from(target.children).filter(el => el.classList.contains('snize-product-filters-block')).forEach(block => {
        const title = block.querySelector('[id$="_title"]')?.textContent.replace(/,.*$/, '').trim();
        groups.push({header:block,body:null,rank:ranks[title] ?? 135});
      });
      const colorGroup = target.querySelector('[data-dac-search-extra="colors"]');
      groups.push({header:colorGroup,body:null,rank:140});
      const ordered = groups.sort((a,b) => a.rank-b.rank).flatMap(group => [group.header,group.body].filter(Boolean));
      const current = Array.from(target.children).filter(el => ordered.includes(el));
      if (current.some((el,i) => el !== ordered[i])) ordered.forEach(el => target.append(el));
    });
    sync(); refreshActive();
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('.snize-product-filters-reset-all')) return;
    const url = read();
    if (url.searchParams.get('dac_colors100') === '1') {
      url.searchParams.delete('dac_colors100');url.searchParams.delete('rb_product_id');
    }
    url.searchParams.delete('rb_discount');
    ++generation;busy = false;checkedAt = 0;
    history.replaceState(history.state,'',url);sync();
  }, true);
  document.addEventListener('change', async event => {
    const input = event.target;
    if (!input.matches('[data-dac-search-extra] input')) return;
    const url = read(), version = ++generation;
    const status = input.closest('[data-dac-search-extra]').querySelector('[role="status"]');
    const checked = input.checked;
    busy = true; status.textContent = "Opdaterer filtre…";
    document.querySelectorAll('[data-dac-search-extra] input').forEach(el => {el.disabled = true;});
    try {
      if (input.name === 'dac_search_sale') checked ? url.searchParams.set('rb_discount','1') : url.searchParams.delete('rb_discount');
      else if (checked) {
        const ids = await colorIds(); if (version !== generation) return;
        url.searchParams.set('dac_colors100','1');url.searchParams.set('rb_product_id',ids);
      } else {url.searchParams.delete('dac_colors100');url.searchParams.delete('rb_product_id');}
      url.searchParams.delete('page'); url.searchParams.delete('startIndex');
      if (config.theme === '179853918401') url.searchParams.set('preview_theme_id',config.theme); else url.searchParams.delete('preview_theme_id');
      location.assign(url);
    } catch (error) {status.textContent = error.message;busy = false;sync();}
  });
  function connect() {
    const jq = window.Searchanise?.$ || window.jQuery;
    if (!jq) return;
    jq(document).off('Searchanise.ResultsUpdated.dacExtra').on('Searchanise.ResultsUpdated.dacExtra',mount);
    mount();
  }
  document.addEventListener('Searchanise.Loaded',connect);
  // The app creates its separate mobile filter surface in response to a click.
  document.addEventListener('click',event => {if (event.target.closest('.snize-filters-dropdown, .snize-filters-mobile, [aria-controls="snize-modal-mobile-filters-dialog"], [data-dac-filters-toggle], .snize-product-filters-header')) requestAnimationFrame(mount);});
  addEventListener('popstate',sync);
  connect();
})();
